import { HistogramState } from './types'
import { addField } from 'live/widgets/helpers'
import _ from 'lodash'

export function getInitialState(): HistogramState {
    return { historyEnded: false, bufferEvents: [], data: [], fields: [] }
}

export function startQuery(action: StartFlowMessage, state: HistogramState): HistogramState {
    if (!action?.events) {
        return state
    }

    const { select } = action.events
    const newState = {
        fields: [],
        groups: []
    }

    select?.forEach(function (field) {
        addField(newState.fields, field)
    })

    return {
        ...state,
        ...newState
    }
}

export function handleEvents(action: EventFlowMessage, state: HistogramState): HistogramState {
    const tempArr = []

    state.fields.forEach(field => {
        action.events.forEach(event => {
            let value = event[field]
            if (_.find(value, 'min') === undefined) value = event[field].bins
            for (const a in value) {
                tempArr.push([value[a].min, value[a].count])
            }
        })
    })

    const newState = {
        ...state,
        data: tempArr
    }

    return newState
}

export function getEndState(action: EndHistoryFlowMessage, state: HistogramState): HistogramState {
    return {
        ...state,
        historyEnded: true
    }
}
